import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import {
  useAutoStartContextCollection,
  useSettleContextConsent,
} from '@/features/context-collection';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';
import { AppCapability, isCapable } from '@/utils/capabilities';

export const useSetupUserAndInitializeChatPolling = () => {
  const user = userStore.user;

  const router = useRouter();

  useAutoStartContextCollection(user?.email);
  useSettleContextConsent(user?.email, userStore.isOnboarded);

  useEffect(() => {
    if (isCapable(AppCapability.Onboarding) && !user?.name?.trim()) {
      router.navigate({
        to: Routes.Onboarding as string,
        replace: true,
      });
    }
  }, [router, user?.name]);
};
